const COLORS = ["#FF5A79", "#2AB7CA", "#9B5DE5", "#FFC02D", "#2EC4B6", "#F15BB5"];

function initials(name) {
  return (name || "P").split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();
}
function colorFor(name) {
  const s = (name || "").split("").reduce((a, c) => a + c.charCodeAt(0), 0);
  return COLORS[s % COLORS.length];
}

export default function Avatar({ user, size = 44, className = "", onClick, testid }) {
  const name = user?.name || "";
  const pic = user?.picture;
  const style = { width: size, height: size, fontSize: size * 0.38 };
  const Tag = onClick ? "button" : "div";
  return (
    <Tag
      type={onClick ? "button" : undefined}
      onClick={onClick}
      data-testid={testid}
      className={`rounded-full overflow-hidden flex items-center justify-center font-bold text-white shrink-0 ${onClick ? "hover:opacity-90 transition" : ""} ${className}`}
      style={pic ? style : { ...style, backgroundColor: colorFor(name) }}
    >
      {pic ? <img src={pic} alt={name} className="w-full h-full object-cover" /> : initials(name)}
    </Tag>
  );
}
